<template>
    <div class="basic_wrap">
        <div class="red_top_bg">
            <div class="back_left" @click="$router.back()"></div>
            <div class="big_tit">{{$t('moneybag.rechargeRecord')}}</div>
        </div>
        <div class="user_yw">
            <p>{{$t('moneybag.accountBalance')}}</p>
            <p>{{$t('utils.moneyMark')}}{{funds}}</p>
        </div>
        <div class="user_zrzc">
            <span @click="$router.push('/invest')">{{$t('moneybag.recharge')}}</span>
            <span @click="$router.push('/cash')">{{$t('moneybag.withdraw')}}</span>
        </div>
        <div class="detail_box">
            <van-empty :description="$t('item.noData')" v-if="listShow" />
            <div class="item" v-for="item in data" :key="item.id">
                <div class="de_wrap">
                    <div class="title_row">
                        <p class="tit">{{item.type || '人民币充值'}}</p>
                        <span class="status" :class="statusClass(item.status)">{{statusText(item.status)}}</span>
                    </div>
                    <p class="order_no">订单号：{{item.orderid}}</p>
                    <p class="time">提交时间：{{item.time}}</p>
                    <p class="time" v-if="item.status === 1 && item.time2 && item.time2 !== '0000-00-00 00:00:00'">通过时间：{{item.time2}}</p>
                    <p class="reason" v-if="item.status === 2 && item.reason">拒绝原因：{{plainReason(item.reason)}}</p>
                </div>
                <div class="price">{{$t('utils.moneyMark')}}{{item.money}}</div>
            </div>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue';
    import Fetch from '../../utils/fetch';
    import { Empty } from 'vant';

    Vue.use(Empty);

    export default {
        name: "rechargeRecord",
        data() {
            return { data: [], listShow: false, funds: '0.00' };
        },
        created() {
            this.$parent.footer('user', false);
        },
        mounted() {
            this.loadRecords();
        },
        methods: {
            loadRecords() {
                Fetch('/user/recharge_records').then(r => {
                    this.data = r.data.list || [];
                    this.funds = r.data.money || '0.00';
                    this.listShow = this.data.length === 0;
                }).catch(() => {});
            },
            statusText(status) {
                return { 0: '审核中', 1: '已通过', 2: '已拒绝', 3: '待提交' }[Number(status)] || '未知状态';
            },
            statusClass(status) {
                return 'status_' + Number(status);
            },
            plainReason(reason) {
                return String(reason || '').replace(/<[^>]+>/g, ' ').replace(/\s+/g, ' ').trim();
            }
        }
    };
</script>

<style lang="less" scoped>
    .red_top_bg { height: 126px; background: #3775f4; position: fixed; }
    .user_yw {
        text-align: center; width: 96%; position: absolute; top: 78px; background: #fff; left: 2%;
        border-radius: 5px 5px 0 0; padding: 20px 0;
        p:first-child { font-size: 16px; color: #646566; margin-bottom: 20px; }
        p:last-child { font-size: 20px; font-weight: bold; }
    }
    .user_zrzc {
        width: 96%; position: absolute; top: 173px; left: 2%; padding: 15px 0; display: flex;
        justify-content: space-between; text-align: center; background: #fff; border-radius: 0 0 5px 5px;
        span { width: 40%; margin: 0 20px; padding: 12px 10px; border-radius: 5px; background: #3775f4; color: #fff; }
    }
    .detail_box {
        width: 96%; margin-left: 2%; margin-top: 244px; background: #fff; border-radius: 6px; padding: 0 12px;
        .item { display: flex; align-items: flex-start; justify-content: space-between; padding: 16px 4px; border-bottom: 1px solid #ececec; }
        .de_wrap { flex: 1; min-width: 0; }
        .title_row { display: flex; align-items: center; gap: 8px; }
        .tit { font-size: 15px; color: #222; line-height: 22px; font-weight: bold; }
        .status { padding: 2px 7px; border-radius: 10px; font-size: 11px; white-space: nowrap; }
        .status_0 { color: #ed6a0c; background: #fff3e8; }
        .status_1 { color: #07a84f; background: #e9f9ef; }
        .status_2 { color: #ee0a24; background: #fff0f1; }
        .status_3 { color: #3775f4; background: #edf3ff; }
        .order_no, .time { margin-top: 7px; color: #888; font-size: 12px; line-height: 17px; word-break: break-all; }
        .reason { margin-top: 7px; color: #ee0a24; font-size: 12px; line-height: 18px; }
        .price { margin-left: 10px; color: #3775f4; font-size: 19px; line-height: 28px; font-weight: bold; white-space: nowrap; }
    }
</style>
